import * as React from 'react';
import numeral from 'numeral';
import makeComp from '../util/profiler';
import {envIsLocal} from '../config';

interface StoragePercentageProps {
  available: number;
  used: number;
  selected?: number;
}

const StoragePercentage: React.FC<StoragePercentageProps> = makeComp(
  ({available, used, selected}) => {
    if (selected == null) {
      selected = 0;
    }
    let percent = used / available;
    let selectedPercent = (used - selected) / available;
    let over = 0;
    if (percent > 1) {
      over = percent - 1;
      percent = available / used;
      selectedPercent = (used - selected) / used;
    }
    return (
      <div>
        {envIsLocal ? (
          <>
            <div
              className="progress"
              style={{
                width: '100%',
                height: 25,
                marginBottom: 10,
                background: '#CCC',
                borderRadius: 5,
                position: 'relative',
              }}>
              <span
                className="used"
                style={{
                  display: 'inline-block',
                  width: '5%',
                  height: '100%',
                  background: 'rgb(175,220,234)',
                  borderRadius: 5,
                }}></span>
            </div>
            <div>
              {numeral(used - selected).format('0.0b')} Used
              {/* TODO: hook up billing <a style={{float: 'right'}} href="/billing">
          Upgrade →
        </a>*/}
            </div>
          </>
        ) : (
          <>
            <div
              className="progress"
              style={{
                width: '100%',
                height: 25,
                marginBottom: 10,
                background:
                  over > 0 && selectedPercent > percent ? '#ffe3e6' : '#CCC',
                borderRadius: 5,
                position: 'relative',
              }}>
              <span
                className="used"
                style={{
                  display: 'inline-block',
                  width: percent * 100 + '%',
                  height: '100%',
                  background: 'rgb(175,220,234)',
                  borderRadius: 5,
                }}></span>
            </div>
            <div>
              Personal plan {numeral(used - selected).format('0.0b')} /{' '}
              {numeral(available).format('0.0b')}
              {/* TODO: hook up billing <a style={{float: 'right'}} href="/billing">
      Upgrade →
    </a>*/}
            </div>
          </>
        )}
      </div>
    );
  },
  {id: 'StoragePercentage', memo: true}
);

export default StoragePercentage;
